export const EVENT_STATUS = {
  FUTURE: "future",
  ACTIVE: "active",
  PAST: "past",
};
